import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, Typography2 } from '@coursera/cds-core';

import HelpTipCardWithDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/HelpTipCardWithDialog';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';

import _t from 'i18n!nls/degree-home';

const ReadyForFullDegreePBAOnly = () => (
  <HelpTipCardWithDialog
    title={_t('Ready for the full degree?')}
    tip={_t('Find out how you can get admitted')}
    dialogTitle={_t('Ready for the full degree?')}
    dialogMessage={
      <Typography2 component="p">
        <FormattedMessage
          message={_t(
            'When you are ready to get admitted, find out about your university’s admissions options by visiting the degree program’s {admissionsPageLink}.'
          )}
          admissionsPageLink={
            <Link target="_blank" rel="noopener noreferrer" href={`./${PATHS.ADMISSIONS}`}>
              {_t('admissions page')}
            </Link>
          }
        />
      </Typography2>
    }
  />
);

export default ReadyForFullDegreePBAOnly;
